import React from 'react';
import Profile from './Profile';

function App() {
  return (
    <div className="App">
      <h1 className='h1'>GitHub Profile Viewer</h1>
      <Profile />
    </div>
  );
}

export default App;
